import { createFileRoute } from "@tanstack/react-router";
import { SolucionesPanel, type SolucionTab } from "@/components/soluciones-panel";

const TABS: SolucionTab[] = [
  { label: "Athena LMS", to: "/soluciones/tecnologia-aprendizaje/athena-lms" },
  { label: "VigIA", to: "/soluciones/tecnologia-aprendizaje/vigia" },
  { label: "FaceID", to: "/soluciones/tecnologia-aprendizaje/face-id" },
  { label: "SonIA", to: "/soluciones/tecnologia-aprendizaje/sonia" },
];

export const Route = createFileRoute("/soluciones/tecnologia-aprendizaje")({
  head: () => ({
    meta: [
      { title: "Tecnología de Aprendizaje | Mine Class" },
      {
        name: "description",
        content:
          "Ecosistema de tecnología para el aprendizaje minero: Athena LMS + Zeus, FaceID de validación biométrica y SonIA, relatora virtual con IA.",
      },
    ],
    links: [{ rel: "canonical", href: "/soluciones/tecnologia-aprendizaje" }],
  }),
  component: Layout,
});

function Layout() {
  return (
    <SolucionesPanel
      title="Tecnología de Aprendizaje"
      intro="LMS minero, IA de validación biométrica y relatoría virtual: la infraestructura tecnológica que potencia la formación en la industria."
      tabs={TABS}
    />
  );
}
